import angular from 'angular';

const userOrderServices = angular.module('applicationModule.userOrderServices', []);

userOrderServices.factory('Order', ['OrderAPI', function (OrderAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return OrderAPI.getOrder(appId, params)
                .then(function (response) {
                    return response.data.order;
                });
        },
        getDetail: function (orderId, appId) {
            return OrderAPI.getOrderDetail(orderId, appId)
                .then(function (response) {
                    return response.data.detail[0];
                });
        }
    };
}]);

userOrderServices.service('OrderAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const ORDER_URL = AppsoupAPI.API_URL + '/app/order/';

    this.getOrder = function (appId, params) {
        return $http.get(ORDER_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getOrderDetail = function (orderId, appId) {
        return $http.get(ORDER_URL + orderId, {application_id: appId});
    };

}]);

export default userOrderServices;
